// Materials section toggle
function toggleMaterials(button) {
    const content = button.nextElementSibling;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // If we're closing the size guide section, also reset the zoomed image
    if (!isExpanded === false && button.closest('.size-fit-section')) {
      const zoomedImage = document.querySelector('.size-chart-image.zoomed');
      if (zoomedImage) {
        closeZoom();
      }
    }
  
    // If we're opening the size guide section, reset any transform on the image
    if (!isExpanded && button.closest('.size-fit-section')) {
      const sizeChartImage = content.querySelector('.size-chart-image');
      if (sizeChartImage) {
        sizeChartImage.style.transform = 'none';
      }
    }
  
    button.setAttribute('aria-expanded', !isExpanded);
    content.style.display = isExpanded ? 'none' : 'block';
  }
  
  // Size Chart zoom and pan functionality
  function toggleImageZoom(img) {
    if (!img.classList.contains('size-chart-image')) return;
    
    let overlay = document.querySelector('.zoom-overlay');
    let closeButton = document.querySelector('.zoom-close-button');
  
    if (!overlay) {
      // Create overlay
      overlay = document.createElement('div');
      overlay.className = 'zoom-overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeZoom);
      
      // Create close button
      closeButton = document.createElement('button');
      closeButton.className = 'zoom-close-button';
      closeButton.innerHTML = '×';
      document.body.appendChild(closeButton);
      closeButton.addEventListener('click', closeZoom);
    }
  
    if (!img.classList.contains('zoomed')) {
      // Zoom in
      img.classList.add('zoomed');
      overlay.style.display = 'block';
      closeButton.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      // Set initial centered position
      img.style.transform = 'translate(-50%, -50%) scale(2)';
      initDragHandlers(img);
    } else {
      // Zoom out
      closeZoom();
    }
  }
    
  function closeZoom() {
    const img = document.querySelector('.size-chart-image.zoomed');
    const closeButton = document.querySelector('.zoom-close-button');
    const sizeGuideButton = document.querySelector('.size-fit-header');
    const sizeGuideContent = document.querySelector('.size-fit-content');
    
    if (img) {
      // Reset zoom
      img.style.transform = 'translate(-50%, -50%) scale(2)';
      img.classList.remove('zoomed');
      document.querySelector('.zoom-overlay').style.display = 'none';
      closeButton.style.display = 'none';
      document.body.style.overflow = '';
      removeDragHandlers(img);
  
      // Close size guide dropdown
      if (sizeGuideButton && sizeGuideContent) {
        sizeGuideButton.setAttribute('aria-expanded', 'false');
        sizeGuideContent.style.display = 'none';
      }
    }
  }
  
  function initDragHandlers(img) {
    let isDragging = false;
    let startX, startY, initialX, initialY;
  
    function handleDragStart(e) {
      isDragging = true;
      const matrix = new DOMMatrix(window.getComputedStyle(img).transform);
      initialX = matrix.m41;
      initialY = matrix.m42;
      startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
      startY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY;
      e.preventDefault();
    }
  
    function handleDrag(e) {
      if (!isDragging) return;
      e.preventDefault();
      const currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
      const currentY = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;
      const deltaX = currentX - startX;
      const deltaY = currentY - startY;
      img.style.transform = `translate(${initialX + deltaX}px, ${initialY + deltaY}px) scale(2)`;
    }
  
    function handleDragEnd() {
      isDragging = false;
    }
  
    img.addEventListener('mousedown', handleDragStart);
    img.addEventListener('touchstart', handleDragStart);
    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('touchmove', handleDrag);
    document.addEventListener('mouseup', handleDragEnd);
    document.addEventListener('touchend', handleDragEnd);
  
    img.dragHandlers = {
      start: handleDragStart,
      move: handleDrag,
      end: handleDragEnd
    };
  }
  
  function removeDragHandlers(img) {
    if (!img.dragHandlers) return;
    
    img.removeEventListener('mousedown', img.dragHandlers.start);
    img.removeEventListener('touchstart', img.dragHandlers.start);
    document.removeEventListener('mousemove', img.dragHandlers.move);
    document.removeEventListener('touchmove', img.dragHandlers.move);
    document.removeEventListener('mouseup', img.dragHandlers.end);
    document.removeEventListener('touchend', img.dragHandlers.end);
    
    delete img.dragHandlers;
  }
  
  // Make functions globally available
  window.toggleMaterials = toggleMaterials;
  window.toggleImageZoom = toggleImageZoom;